<template>
    <div>
        <client-list ref="clientList" :individual-provider="!isInstitution"/>
        <attention-summary-drawer v-if="isAttentionScreen && currentEvent && currentEvent.event_status_id === 4"/>
        <client-attention-history ref="clientAttentionHistory" />
        <appointment-provider-stepper
                ref="stepper"
                internal
        />

        <docs-manager
                v-if="currentEvent"
                :event="currentEvent"
                ref="docsManager"
                :docs="documents" />

        <video-call-tools v-if="showVCTools" />

        <v-footer fixed :class="['toolset transparent', {'hidden': hidden}]" v-if="isAttentionScreen">
            <v-spacer></v-spacer>

            <v-card
                    flat
                    class="px-1 toolset-card"
                    @click="hidden = false">

                <div v-show="false" class="toolset-bg" :style="{'background-image': `url('${require('@/assets/img/menu-bg.jpg')}')`}"></div>

                <!--Refresh btn-->
                <v-btn :disabled="loadingEvent" v-if="currentEvent" fab small @click="refreshEvent">
                  <v-icon>fa-sync {{loadingEvent ? 'fa-spin' : ''}}</v-icon>
                </v-btn>

                <!--Documents button-->
                <template v-if="currentEvent">
                    <v-btn class="hidden-md-and-up ma-1" color="secondary" round fab small dark @click="showDocsManager">
                        <v-icon size="16">fa-paperclip</v-icon>
                    </v-btn>

                    <v-btn class="hidden-sm-and-down px-3" color="secondary" round depressed small dark @click="showDocsManager">
                        <v-icon size="16" class="mr-1">fa-paperclip</v-icon>
                        Adjuntos
                    </v-btn>
                </template>


                <!--New appointment button-->
                <v-btn class="hidden-md-and-up ma-1" color="primary" round fab small dark @click="showNewAppointment(null)">
                    <v-icon size="16">far fa-calendar-plus</v-icon>
                </v-btn>

                <v-btn class="hidden-sm-and-down px-3" color="primary" round depressed small dark @click="showNewAppointment(null)">
                    <v-icon size="16" class="mr-1">far fa-calendar-plus</v-icon>
                    Nueva cita
                </v-btn>

                <!--Show history button-->
                <template v-if="currentClient">
                    <v-btn class="hidden-md-and-up ma-1" color="teal" round fab small dark @click="$refs.clientAttentionHistory.show(currentClient.id)">
                        <v-icon size="16">fas fa-history</v-icon>
                    </v-btn>

                    <v-btn class="hidden-sm-and-down px-3" color="teal" round depressed small dark @click="$refs.clientAttentionHistory.show(currentClient.id)">
                        <v-icon size="16" class="mr-1">fas fa-history</v-icon>
                        Historial de {{ currentClient && currentClient.first_name || getLabel('commons.client.singular').toLowerCase()}}
                    </v-btn>
                </template>

                <!--Show clients button-->
                <v-btn class="hidden-md-and-up ma-1" color="info" round fab small dark @click="$refs.clientList.showClientList()">
                    <v-icon size="16">fas fa-users</v-icon>
                </v-btn>

                <v-btn class="hidden-sm-and-down px-3" color="info" round depressed small dark @click="$refs.clientList.showClientList()">
                    <v-icon size="16" class="mr-1">fas fa-users</v-icon>
                    {{ getLabel('commons.client.plural')}} del día
                </v-btn>

                <v-btn depressed fab small class="close-btn" @click.stop="hidden = true">
                    <v-icon>{{'fa-times'}}</v-icon>
                </v-btn>

            </v-card>

            <v-spacer></v-spacer>
        </v-footer>

        <floating-spinner v-if="requiresGlobalSpinner" />

    </div>
</template>
<script>
    import AttentionSummaryDrawer from './AttentionSummaryDrawer'
    import ClientAttentionHistory from '@/components/appointments/attention/ClientAttentionHistory'
    import AppointmentProviderStepper from '@/components/appointments/AppointmentProviderStepper'
    import VideoCallTools from '@/components/appointments/attention/toolset/VideoCallTools'
    import DocsManager from '@/components/appointments/attention/DocsManager'
    import FloatingSpinner from '@/components/appointments/attention/toolset/FloatingSpinner'

    import ClientList from './ClientList'
    import {getLabel} from '@/utils/Institution'
    import {requiresGlobalSpinner} from '@/utils/Specialist'

    import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'

    import {mapState, mapMutations} from 'vuex'
    import OnlineWatcher from "../../../common/OnlineWatcher";

    export default{
        data(){
            return {
                hidden: false,
                documents: []
            }
        },
        components: {
          OnlineWatcher,
            FloatingSpinner,
            ClientList,
            AttentionSummaryDrawer,
            ClientAttentionHistory,
            AppointmentProviderStepper,
            VideoCallTools,
            DocsManager
        },
        mounted(){
            var vm = this
            if(!!vm.currentEvent){
                vm.connectSocket()
                vm.documents = vm.currentEvent.appointment_documents || []
            }
            console.log('currentEvent',vm.currentEvent)
        },
        beforeDestroy(){
            var vm = this
            if(!vm.currentEvent) return
            leaveChannel(`appointment.${vm.currentEvent.id}`)
        },
        methods:{
            ...mapMutations('clientAttention', [
                'setEvent'
            ]),
            getLabel,
            refreshEvent(){
                const vm = this
                let currentEvent = JSON.parse(JSON.stringify(vm.currentEvent))
                vm.setEvent(currentEvent)
            },
            connectSocket(){
                var vm = this
                subscribeToPrivateChannelEvents(`appointment.${vm.currentEvent.id}`, {
                    'AppointmentDocumentUploaded': vm.onDocumentUploaded,
                    'AppointmentDocumentDeleted': vm.onDocumentDeleted,
                    'PaymentUpdated': vm.onPaymentUpdated,
                    'ClientArrived': vm.onClientArrived,
                })
            },
            onPaymentUpdated({event}){
                var vm = this

                if(vm.currentEvent && event.payment){
                    var currentEvent = JSON.parse(JSON.stringify(vm.currentEvent))
                    currentEvent.payment = event.payment
                    vm.setEvent(currentEvent)
                }
            },
            onClientArrived({event}){
                var vm = this

                if(vm.currentEvent.event_status_id !== event.event_status_id){
                    vm.setEvent(event)
                }
            },
            onDocumentDeleted({document}){
              const vm = this
              const index = vm.documents.findIndex(doc => doc.id === document.id)
              if(index !== -1){
                vm.documents.splice(index, 1)
              }
            },
            onDocumentUploaded({document}){
                var vm = this
                if(document.user.id !== vm.currentUser.id){
                    vm.$store.commit('showSnackBar', {
                        text: 'Se ha cargado un nuevo documento',
                        color: 'success'
                    })
                }
                const index = vm.documents.findIndex(doc => doc.id === document.id)
                if(index === -1){
                  vm.documents.push(document)
                }
            },
            showDocsManager(){
                var vm = this
                vm.$refs.docsManager.show()
            },
            showNewAppointment(defaultAppointment = null){
                this.$refs.stepper.show(defaultAppointment)
            }
        },
        computed: {
            ...mapState('clientAttention', {
                currentClient: state => state.currentClient,
                currentEvent: state => state.currentEvent,
                loadingEvent: state => state.loading,
                attentionSummaryDrawer: state => state.attentionSummaryDrawer
            }),
                ...mapState(['currentUser', 'currentProvider']),
            requiresGlobalSpinner,
            isAttentionScreen(){
                return this.$route.name === 'panel.provider.specialist_daily_schedule'
            },
            isInstitution(){
                var vm = this
                return !!vm.currentProvider && !!vm.currentProvider.institution
            },
            showVCTools(){
                var vm = this
                return vm.currentEvent &&
                        vm.currentEvent.type === 'video' &&
                        (
                            vm.currentEvent.event_status.id === 4
                        )
            }
        },
        watch:{
            currentEvent(val, oldVal){
                var vm = this

                if(oldVal){
                    leaveChannel(`appointment.${oldVal.id}`)
                }

                if(val){
                    vm.documents = val.appointment_documents || []
                    leaveChannel(`appointment.${val.id}`)
                    vm.connectSocket()
                }else{
                    vm.documents = []
                }
            },
        }
    }
</script>

<style scoped>
    .toolset{
        bottom: -5px !important;
        transition: .3s bottom;
        font-family: Roboto, sans-serif;
        font-size: 12px !important;
    }

    .toolset.hidden{
        bottom: -45px !important;
    }

    .toolset.hidden .toolset-card{
        cursor: pointer;
    }

    .toolset-card{
        background-color: rgba(196, 201, 202, 0.78);
        padding: 5px 15px 30px 15px!important;
        border-radius: 30px !important;
    }

    .toolset-bg{
        position: absolute;
        background-size: cover;
        opacity: .6;
        background-position: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.8);
    }

    .close-btn{
        width: 35px;
        height: 35px;
    }


</style>